
export const basic = [
    ['fontSize'],
    ['fontColor'],
    ['horizontalRule'],
    ['link', 'imageGallery']
]
